var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view agenda"},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-container',{staticClass:"modal-progress"},[_c('v-progress-circular',{staticClass:"progress",attrs:{"indeterminate":"","size":60,"color":"primary"}})],1)],1),_c('v-container',{staticClass:"content"},[_c('v-row',[_c('v-col',{staticClass:"form-title",style:('font-size: 20px; font-weight: bold;')},[_vm._v(" Registration to "+_vm._s(_vm.$store.getters.getMeeting.name)+" ")])],1),_c('v-row',[_c('v-col',{style:('max-width: 80%;')},[_c('v-btn',{staticClass:"mr-4 my-2 action-button",attrs:{"color":"green","depressed":""}},[_vm._v("Agenda F2F "+_vm._s(_vm.$store.getters.getMeeting.place)+", "+_vm._s(_vm.moment(_vm.$store.getters.getMeeting.dateFrom).format("YYYY")))]),_c('v-btn',{staticClass:"mr-4 my-2 action-button",attrs:{"color":"grey","depressed":""},on:{"click":_vm.onAccount}},[_vm._v("Registration F2F "+_vm._s(_vm.$store.getters.getMeeting.place)+", "+_vm._s(_vm.moment(_vm.$store.getters.getMeeting.dateFrom).format("YYYY")))]),_c('v-btn',{staticClass:"mr-4 my-2 action-button",attrs:{"plain":""}},[_vm._v(_vm._s(_vm.$store.getters.getUserAuth.firstName + " " + _vm.$store.getters.getUserAuth.lastName))])],1),_c('v-col'),_c('v-col',{style:('max-width: 20%;')},[_c('v-icon',{staticClass:"my-2 action-button",attrs:{"depressed":""},on:{"click":_vm.onReload}},[_vm._v("mdi-reload")])],1)],1),_c('v-row',[_c('v-col',{staticClass:"zone-wrapper"},[_vm._v(" EVENT TIME ZONE: "),_c('span',{staticClass:"zone"},[_vm._v(_vm._s(_vm.getEventZone()))])])],1)],1),(_vm.days)?_c('v-container',[_vm._l((_vm.daysFuture),function(day,k){return _c('div',{key:k,staticClass:"agenda-wrapper"},[_c('div',{staticClass:"agenda-header"},[_vm._v(" "+_vm._s(_vm.moment(day.date).format("dddd DD.MM. YYYY"))+" ")]),_c('div',{staticClass:"agenda-rooms-header"},[_c('div',{staticClass:"room rooms-title"}),_vm._l((day.rooms),function(room,k){return _c('div',{key:k,staticClass:"room"},[_vm._v(" "+_vm._s(room.name)+" ")])})],2),_vm._l((day.times),function(row,i){return _c('div',{key:i},[(row.sequence == 'ALLROOMS')?[_c('div',{staticClass:"agenda-times"},[_c('div',{staticClass:"agenda-time break-time"},[_c('div',{staticClass:"time-span"},[_vm._v(_vm._s(row.from)+" - "+_vm._s(row.to))]),_c('div',{staticClass:"time-title"},[_vm._v(_vm._s(row.title))])])])]:_vm._e(),(row.sequence == 'ROOMS')?[_c('div',{staticClass:"agenda-rooms"},[_c('div',{staticClass:"time-span"},[_vm._v(_vm._s(row.from)+" - "+_vm._s(row.to))]),_vm._l((day.rooms.length),function(slot,j){return _c('div',{key:j,staticClass:"agenda-slot",style:({
                  backgroundColor: _vm.getSchedule(
                    day.rooms[j],
                    row.from,
                    row.to,
                    day.date,
                    day,
                    j
                  ).color,
                })},[_c('div',{staticClass:"slot-title"},[_vm._v(" "+_vm._s(_vm.getSchedule( day.rooms[j], row.from, row.to, day.date, day, j ).name)+" ")]),(
                    _vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).register
                  )?_c('div',{class:{
                    'slot-register': true,
                    scheduled: _vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).isScheduled,
                  },on:{"click":function($event){_vm.onRegister(
                      _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      )
                    )}}},[(
                      _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      ).isScheduled
                    )?[_c('div',{staticClass:"slot-register-checkbox"},[_c('img',{attrs:{"src":require("@/assets/images/registered.svg")}})]),_c('div',{staticClass:"slot-register-text"},[_vm._v("REGISTERED")])]:[_c('div',{staticClass:"slot-register-checkbox"}),_c('div',{staticClass:"slot-register-text"},[_vm._v("REGISTER")])]],2):_vm._e(),(_vm.isDateToday(day.date))?[(
                      _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      ).register
                    )?_c('div',{class:{
                      'slot-checkin': true,
                      scheduled: _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      ).isChecked,
                    },on:{"click":function($event){_vm.onCheckin(
                        _vm.getSchedule(
                          day.rooms[j],
                          row.from,
                          row.to,
                          day.date,
                          day,
                          j
                        )
                      )}}},[(
                        _vm.getSchedule(
                          day.rooms[j],
                          row.from,
                          row.to,
                          day.date,
                          day,
                          j
                        ).isChecked
                      )?[_c('div',{staticClass:"slot-register-checkbox"},[_c('img',{attrs:{"src":require("@/assets/images/registered.svg")}})]),_c('div',{staticClass:"slot-register-text"},[_vm._v(" CHECKED-IN ")])]:[_c('div',{staticClass:"slot-register-checkbox"}),_c('div',{staticClass:"slot-register-text"},[_vm._v("CHECK-IN")])]],2):_vm._e()]:_vm._e()],2)}),_c('div')],2)]:_vm._e(),(row.sequence == 'SOCIAL_EVENT')?[_c('div',{staticClass:"agenda-times"},[_c('div',{staticClass:"agenda-time break-time social-event"},[_c('div',{staticClass:"time-span"},[_vm._v(_vm._s(row.from)+" - "+_vm._s(row.to))]),_c('div',{staticClass:"time-title"},[_c('div',{staticClass:"social-event-title"},[_vm._v(_vm._s(row.title))]),_c('span',{staticClass:"social-event-description"},[_vm._v(_vm._s(row.description))]),(_vm.isSocialEventRegistered(row, day.date))?[_c('div',{staticClass:"slot-register scheduled",on:{"click":function($event){return _vm.onUnRegisterSocialEvent(day.date, row.from, row.to)}}},[_c('div',{staticClass:"slot-register-checkbox"},[_c('img',{attrs:{"src":require("@/assets/images/registered.svg")}})]),_c('div',{staticClass:"slot-register-text"},[_vm._v("REGISTERED")])])]:[_c('div',{staticClass:"slot-register",on:{"click":function($event){return _vm.onRegisterSocialEvent(day.date, row.from, row.to)}}},[_c('div',{staticClass:"slot-register-checkbox"}),_c('div',{staticClass:"slot-register-text"},[_vm._v("REGISTER")])])]],2)])])]:_vm._e()],2)})],2)}),_vm._l((_vm.daysPast),function(day,k){return _c('div',{key:k + 'past',staticClass:"agenda-wrapper past"},[(k == 0)?[_c('div',{staticClass:"past-days"},[_c('v-row',[_c('v-col',[_c('v-row',{staticClass:"past-day-banner"},[_vm._v("PASTS DAYS")]),_c('v-row',{staticClass:"past-day-text"})],1)],1)],1)]:_vm._e(),_c('div',{staticClass:"agenda-header"},[_vm._v(" "+_vm._s(_vm.moment(day.date).format("dddd DD.MM. YYYY"))+" ")]),_c('div',{staticClass:"agenda-rooms-header"},[_c('div',{staticClass:"room rooms-title"}),_vm._l((day.rooms),function(room,k){return _c('div',{key:k,staticClass:"room"},[_vm._v(" "+_vm._s(room.name)+" ")])})],2),_vm._l((day.times),function(row,i){return _c('div',{key:i},[(row.sequence == 'ALLROOMS')?[_c('div',{staticClass:"agenda-times"},[_c('div',{staticClass:"agenda-time break-time"},[_c('div',{staticClass:"time-span"},[_vm._v(_vm._s(row.from)+" - "+_vm._s(row.to))]),_c('div',{staticClass:"time-title"},[_vm._v(_vm._s(row.title))])])])]:_vm._e(),(row.sequence == 'ROOMS')?[_c('div',{staticClass:"agenda-rooms"},[_c('div',{staticClass:"time-span"},[_vm._v(_vm._s(row.from)+" - "+_vm._s(row.to))]),_vm._l((day.rooms.length),function(slot,j){return _c('div',{key:j,staticClass:"agenda-slot",style:({
                  backgroundColor: _vm.getSchedule(
                    day.rooms[j],
                    row.from,
                    row.to,
                    day.date,
                    day,
                    j
                  ).color,
                })},[_c('div',{staticClass:"slot-title"},[_vm._v(" "+_vm._s(_vm.getSchedule( day.rooms[j], row.from, row.to, day.date, day, j ).name)+" ")]),(
                    _vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).register
                  )?_c('div',{class:{
                    'slot-register': true,
                    scheduled: _vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).isScheduled,
                  }},[(
                      _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      ).isScheduled
                    )?[_c('div',{staticClass:"slot-register-checkbox"},[_c('img',{attrs:{"src":require("@/assets/images/registered.svg")}})]),_c('div',{staticClass:"slot-register-text"},[_vm._v("REGISTERED")])]:_vm._e()],2):_vm._e(),(
                    _vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).register
                  )?_c('div',{class:{
                    'slot-checkin': true,
                    scheduled: _vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).isChecked,
                    'not-scheduled': !_vm.getSchedule(
                      day.rooms[j],
                      row.from,
                      row.to,
                      day.date,
                      day,
                      j
                    ).isChecked,
                  },on:{"click":function($event){_vm.onCheckin(
                      _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      )
                    )}}},[(
                      _vm.getSchedule(
                        day.rooms[j],
                        row.from,
                        row.to,
                        day.date,
                        day,
                        j
                      ).isChecked
                    )?[_c('div',{staticClass:"slot-register-checkbox"},[_c('img',{attrs:{"src":require("@/assets/images/registered.svg")}})]),_c('div',{staticClass:"slot-register-text"},[_vm._v("CHECKED-IN")])]:[_c('div',{staticClass:"slot-register-checkbox"}),_c('div',{staticClass:"slot-register-text"},[_vm._v("CHECK-IN")])]],2):_vm._e()])}),_c('div')],2)]:_vm._e()],2)})],2)})],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }